import { Injectable } from '@angular/core';

import { GoogleMap } from '@lib/geo/google/map';
import { SnLonLat, SnLonLatLike } from '@lib/geo/helpers';

import { BaseGeometricNavigationService } from '../base-geometric-navigation.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleGeometricNavigationService extends BaseGeometricNavigationService {
  private _map?: GoogleMap;

  constructor() {
    super();
  }

  public setMap(map: GoogleMap): void {
    this._map = map;
  }

  public setCenter(coords: SnLonLatLike): void {
    if (!this._map) return;
    const lonLat = SnLonLat.convert(coords);
    this._map.mapInstance.setCenter(new google.maps.LatLng(lonLat.lat, lonLat.lon));
  }

  public goToCoordinates(coords: SnLonLatLike, zoom: number = 18): void {
    if (!this._map) return;
    this.setCenter(coords);
    this._map.mapInstance.setZoom(zoom);
  }

  public async panTo(coords: SnLonLatLike, options?: Record<string, unknown>): Promise<void> {
    if (!this._map) return;
    const lonLat = SnLonLat.convert(coords);
    this._map.mapInstance.panTo(new google.maps.LatLng(lonLat.lat, lonLat.lon));
    return Promise.resolve();
  }

  public getCenter(): SnLonLat {
    if (!this._map) {
      throw new Error('Map not set. Call setMap() first.');
    }

    const center = this._map.mapInstance.getCenter();
    if (!center) {
      throw new Error('Map center is not available');
    }
    return new SnLonLat(center.lng(), center.lat());
  }
}
